/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */
import React from 'react';

export default (): JSX.Element => (
  <svg width={18} height={12} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.228 3.099l3.044 3.317-3.315 3.045M5.211 3.029L1.896 6.082 4.94 9.399m5.228-7.473L7.76 10.603"
      stroke="#4C9AFF"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
